import { Component, OnInit, Input, Renderer, ElementRef } from "@angular/core";
import { UserAuthService } from "../user-auth.service";
import { MessageService } from '../../../core/services/message.service';
import { LoginUserService } from '../../../core/services/login-user.service';
import { Router, ActivatedRoute } from "@angular/router";

declare var returnCitySN;

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent implements OnInit {
  username: string;
  password: string;
  errorColor: boolean = false;//错误提示
  public ip: string = null;//用户id
  constructor(
    private _renderer: Renderer,
    private _el: ElementRef,
    private _service: UserAuthService,
    private _msg: MessageService,
    private _router: Router,
    private _login: LoginUserService,
  ) { }

  ngOnInit() {
    if (returnCitySN['cip']) { this.ip = returnCitySN['cip']; }
  }
  regUsername() {
    let mobile_reg = RegExp(/^[1]\d{10}$/); // new RegExp(/^0{0,1}(13[0-9]|15[0-9]|153|156|177|18[0-9]|19[0-9])[0-9]{8}$/);
    let email_reg = new RegExp(/^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/);
    if (!!this.username) {
      if (!mobile_reg.test(this.username.trim()) && !email_reg.test(this.username.trim())) {
        this._msg.warn('用户名格式不正确!');
        this.errorColor = true;
        setTimeout(() => {
          this._msg.clear();
        }, 3000);
        return false;
      } else {
        this.errorColor = false;
        return true;
      }
    }
  }

  //登录请求
  login() {
    if (!this.username) {
      this.username = '';
      this._msg.warn('请输入用户名!');
      setTimeout(() => {
        this._msg.clear();
      }, 3000);
      return false;
    }
    this._service.login(this.username.trim(), this.password, this.ip).then(resp => {
      if (resp['data']) {
        let obj = resp['data']['user'];
        this._msg.success(resp['data']['msg']);
        if (obj['type'] === 3) {
          obj['company_id'] = obj['userInfo']['id'];
          obj['logo'] = obj['userInfo']['logo'];
        } else if (obj['type'] === 1) {
          obj['student_id'] = obj['userInfo']['id'];
          //获取学生简历id
          obj['resume_id'] = obj['userInfo']['resume_id'];
          obj['headimg'] = obj['userInfo']['headimg'];
        }
        if (resp['data']['uchead']) {
          obj['uchead'] = resp['data']['uchead']
        }
        delete obj['userInfo'];
        let a = this._login.setLogin(obj)
        if (a) {

          //是否第一次登录，或信息是否完善判断函数
          this.isFirstLogin(this._login.isFistLogin());
          // console.log("登录请求", resp['data']['user']); //已登录
          setTimeout(() => {
            this._msg.clear();
          }, 3000);
        }

      } else {
        this._msg.warn("用户名或密码错误！");
        setTimeout(() => {
          this._msg.clear();
        }, 3000);
      }
    });
  }
  //是否第一次登录，或信息是否完善判断函数
  isFirstLogin(cc) {
    // console.log("是否第一次登录", cc); //已登录
    //判断处理
    if (cc) {// 是第一次登录  跳转到完善信息页面
      // console.log(11111);
      this._router.navigate(['/user-info/user-complete']);
    } else {// 不是第一次登录  跳转到主页面 或  登录时当前页
      this._router.navigate(['/']);
      // window.location.href = '/home';
    }
  }
  //忘记密码
  forgot() {
    this._router.navigate(['/user-info/forgot-password']);
  }
}



// WEBPACK FOOTER //
// /data/wwwroot/xzhipin/app-client/src/app/shared/user-auth/login/login.component.ts